import { inject, Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { AdminBoxSaleStatus } from '../enums/admin-box-sale-status';
import { AdminBoxSaleStatusProviderService } from '../providers/admin-box-sale-status-provider.service';

@Pipe({
  name: 'adminBoxSaleStatus',
})
export class AdminBoxSaleStatusPipe implements PipeTransform {
  private readonly provider = inject(AdminBoxSaleStatusProviderService);

  public transform(status: AdminBoxSaleStatus): Observable<string> {
    return this.provider.labelFor(status);
  }
}
